import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import messages, {errorMessages} from './messages';
import {DisplaySmall} from 'components/primitives/display';
import {supportColors} from 'components/primitives/color';
import {FormField} from 'components/inputs/FormField';
import {TextInput} from 'components/inputs/Input';
import {Button} from 'components/buttons/Button';
import {Div, P} from 'components/primitives/body';
import GraphQLError from 'components/GraphQLError';
import {Header} from '../../../../components/primitives/header';
import {clearAuthTokens} from 'services/auth/utils';


const LINK_RECOVER = '/login/recover';


const Recover = () => {
    return (
        <Div>
            <Link to={LINK_RECOVER}>
                <FormattedMessage {...messages.recover}/>
            </Link>
        </Div>
    );
};


class LoginForm extends React.Component {
    static propTypes = {
        login: PropTypes.func,
        loginResult: PropTypes.object,
        intl: intlShape,
        preFilledEmail: PropTypes.string,
        message: PropTypes.string
    };

    state = {
        missingRequiredFields: false
    };

    componentDidMount() {
        clearAuthTokens();
    }

    handleSubmit = (e) => {
        if (e) {
            e.preventDefault();
        }

        const email = this.emailField.value;
        const password = this.passwordField.value;

        if (!email || !password) {
            this.setState({missingRequiredFields: true});

            return;
        }

        this.setState({missingRequiredFields: false}, () => {
            this.props.login(email, password);
        });
    };

    getErrorMessageFromLoginResult = (loginResult) => {
        if (!loginResult.called || loginResult.loading) {
            return null;
        }

        if (loginResult.error) {
            return <GraphQLError error={loginResult.error}/>;
        }

        if (!loginResult.data.login.ok) {
            const errorMessage = loginResult.data.login.errorMessage;
            const message = errorMessages[errorMessage] ? errorMessages[errorMessage] : errorMessages.UNKNOWN;
            return <FormattedMessage {...message}/>;
        }
    };

    setEmailFieldRef = inputField => {
        this.emailField = inputField;
    };

    setPasswordFieldRef = inputField => {
        this.passwordField = inputField;
    };

    render() {
        const {loginResult} = this.props;

        return (
            <Wrapper>
                <Header>
                    <DisplaySmall>
                        <FormattedMessage {...messages.title}/>
                    </DisplaySmall>
                </Header>
                {this.props.message && messages[this.props.message] ? (
                    <P sub={true}>
                        <FormattedMessage {...messages[this.props.message]}/>
                    </P>
                ) : null}

                <FormWrapper>
                    <form onSubmit={this.handleSubmit}>
                        <FormField>
                            <TextInput
                                type="email"
                                fullWidth={true}
                                defaultValue={this.props.preFilledEmail}
                                placeholder={this.props.intl.formatMessage(messages.email)}
                                innerRef={this.setEmailFieldRef}
                            />
                        </FormField>

                        <FormField>
                            <TextInput
                                type="password"
                                fullWidth={true}
                                placeholder={this.props.intl.formatMessage(messages.password)}
                                innerRef={this.setPasswordFieldRef}
                            />
                        </FormField>

                        <FormField>
                            <Button
                                type="submit"
                                loading={loginResult.loading}
                                disabled={loginResult.loading}
                                style={{minWidth: '160px'}}
                            >
                                <FormattedMessage {...messages.login}/>
                            </Button>

                        </FormField>

                        {this.state.missingRequiredFields ? (
                            <ErrorMessage>
                                <FormattedMessage {...messages.missingRequiredFields}/>
                            </ErrorMessage>
                        ) : null}

                        <ErrorMessage>
                            {this.getErrorMessageFromLoginResult(loginResult)}
                        </ErrorMessage>

                        <FormField>
                            <Recover/>
                        </FormField>
                    </form>
                </FormWrapper>
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`
`;

const FormWrapper = styled.div`
   margin: 12px 0;
`;

const ErrorMessage = styled(Div)`
  color: ${supportColors.crimson};
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
  min-height: 14px;
`;

export default injectIntl(LoginForm);
